import WorkHistoryStatus from './WorkHistoryStatus'

export default WorkHistoryStatus;